import { animate, state, style, transition, trigger, group } from '@angular/animations';

export const FOLD_OUT_TOGGLE_ANIMATION = trigger('collapsibleToggle', [
  state('in', style({ height: '*', paddingTop: '*', paddingBottom: '*', marginTop: '*', marginBottom: '*' })),
  state(
    'out',
    style({
      overflow: 'hidden',
      height: '0px',
      paddingTop: '0px',
      paddingBottom: '0px',
      marginTop: '0px',
      marginBottom: '0px',
      opacity: 1
    })
  ),
  transition('void => in', [
    style({
      height: '0px',
      'padding-top': '0',
      'padding-bottom': '0',
      'margin-top': '0',
      'margin-bottom': '0',
      opacity: 1
    }),
    animate(
      '250ms ease',
      style({ height: '*', paddingTop: '*', paddingBottom: '*', marginTop: '*', marginBottom: '*' })
    )
  ]),
  transition('out => in', [
    group([
      animate('100ms', style({ opacity: 1 })),
      animate(
        '250ms ease',
        style({ height: '*', paddingTop: '*', paddingBottom: '*', marginTop: '*', marginBottom: '*' })
      )
      // firefox breaks on padding * margin * directives, use explicit Top/Bottom
    ])
  ]),
  transition('in => out', [
    group([
      animate('100ms 150ms', style({ opacity: 0 })),
      animate(
        '250ms ease',
        style({
          height: '0px',
          borderTop: '0px',
          borderBottom: '0px',
          paddingTop: '0px',
          paddingBottom: '0px',
          marginBottom: '0px',
          marginTop: '0px !important'
        })
      ),
      style({ overflow: 'hidden' })
      // animate('250ms ease', style({ height: '0px', padding: '0px', margin: '0px' }))
      // firefox breaks on padding * margin * directives, use explicit Top/Bottom
    ])
  ])
]);
